import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantShopMenuPage } from './merchant-shop-menu';

@NgModule({
  declarations: [
    MerchantShopMenuPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantShopMenuPage),
    TranslateModule.forChild()
  ],
})
export class MerchantShopMenuPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-menu/merchant-shop-menu.module.ts